import React from "react";

export default ({ styles, tagText }) => (
  <div className={styles.tag}>
    <div className={styles.tagText}>{tagText}</div>
  </div>
);
